import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCachedPermissao } from "../utils/getCachedPermissao";
import toast from "react-hot-toast";
import { checkAutenticationByUrl } from "../utils/checkAuthByUrl";
import { getTokens } from "../services/data";

export function useCheckPermissaoSegura(): boolean {
  const [ok, setOk] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        await checkAutenticationByUrl();
      } catch {}

      const tokens = getTokens();
      if (!tokens["x-auth-token"] || !tokens["x-tn-token"]) {
        const cb = window.location.pathname + window.location.search;
        localStorage.setItem("callback", cb);
        navigate(`/?callback=${encodeURIComponent(cb)}` , { replace: true });
        return;
      }

      const permissoes = await getCachedPermissao();

      if (!mounted) return;

      if (!permissoes || permissoes.permissao === "LEITOR") {
        toast.error("Você não tem permissão para acessar esta funcionalidade.");
        const cb = window.location.pathname + window.location.search;
        localStorage.setItem("callback", cb);
        navigate(`/?callback=${encodeURIComponent(cb)}` , { replace: true });
      } else {
        setOk(true);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  return ok;
}
